import { Sparkles } from "lucide-react";
import type { ReactElement } from "react";
import { useTranslation } from "react-i18next";

import { useHelp } from "@/components/layout/HelpProvider";
import { Button } from "@/components/ui/button";
import { Tooltip, TooltipContent, TooltipTrigger } from "@/components/ui/tooltip";

export function HelpAiShortcutButton(): ReactElement {
  const { t } = useTranslation();
  const { openChat } = useHelp();
  const label = t("help.askAssistant");

  return (
    <Tooltip>
      <TooltipTrigger asChild>
        <Button
          type="button"
          variant="ghost"
          size="icon"
          className="size-9 shrink-0 lg:size-12"
          aria-label={label}
          onClick={() => openChat()}
        >
          <span className="flex size-7 items-center justify-center rounded-full bg-primary text-primary-foreground">
            <Sparkles className="size-3.5" aria-hidden />
          </span>
        </Button>
      </TooltipTrigger>
      <TooltipContent side="bottom">{label}</TooltipContent>
    </Tooltip>
  );
}
